module.exports = __webpack_public_path__ + "media/images/products/category/sm/2-7d658f85658408507d571ea1f5e6b87b.jpg";